import React from 'react';

const SvgComponent = props => (
    <svg viewBox="-5 -5 60 60" {...props}>
        <path d="M25 2C12.309 2 2 12.309 2 25c0 9.832 6.184 18.246 14.875 21.531.52.188 1.09-.078 1.281-.593l4.969-13.094a.987.987 0 0 0-.02-.782.975.975 0 0 0-.574-.53C19.887 30.531 18 28.003 18 25c0-3.879 3.121-7 7-7s7 3.121 7 7c0 3.004-1.887 5.531-4.531 6.531a.975.975 0 0 0-.574.532.987.987 0 0 0-.02.78l4.969 13.094c.191.516.761.782 1.281.594C41.816 43.246 48 34.832 48 25 48 12.309 37.691 2 25 2zm0 2c11.61 0 21 9.39 21 21 0 8.621-5.27 15.918-12.688 19.156l-4.25-11.218C31.973 31.445 34 28.488 34 25c0-4.957-4.043-9-9-9s-9 4.043-9 9c0 3.488 2.027 6.445 4.938 7.938l-4.25 11.218C9.27 40.918 4 33.621 4 25 4 13.39 13.39 4 25 4z" />
    </svg>
);

export default SvgComponent;
